import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=4cb0094e&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"
import style0 from "./countdown.vue?vue&type=style&index=0&id=4cb0094e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb0094e",
  null
  
)

export default component.exports